import React from 'react';
import styled from 'styled-components'

const ServiceComp = ({ item, index }) => {
    return (
        <Container>
            <div className={(index % 2 === 0) ? 'item' : 'item reverse'}>
                <ContainerText>
                    <span>{item.title}</span>
                    <h4>{item.titleDes}</h4>
                    <p>{item.description}</p>
                </ContainerText>
                <ContainerImage>
                    <img src={item.img} alt={item.title} />
                </ContainerImage>
            </div>
        </Container>
    )
}

export default ServiceComp

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 1rem 5rem 5rem 5rem;    */
    padding: 1rem 5rem 5rem 5rem;   
    background: #fff;
    .item{
       display: flex;
       justify-content: space-between;
       /* background-color: red; */
    }
   .reverse{
       flex-direction: row-reverse;
    }
    @media screen and (max-width: 900px){
        .item, .reverse{
            flex-direction: column;
        }
        padding: 2rem 0.5rem;
        padding: 1rem 0.5rem 4rem 0.5rem;
    }
`

const ContainerText = styled.div`
    color: #000219;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 0rem 1rem;
    /* align-items: center; */
    span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
    }
    h4{
        color: #000219;
        font-size: 2.2rem;
    }
    p{
        color: #000219;
        font-size: 1.2rem;
        line-height: 1.5;
    }
    a {
        text-align: center;
        text-decoration: none;
        padding: 0.8rem 1rem;
        font-size: 1.3rem;
        color: #fff;
        transition: 0.3s ease;
        margin: 1rem 0rem;
        border: none;
        box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.4) inset;
        background: #E21F36;
        &:hover {
        /* opacity: 0.8; */
        background: orangered;
        }
    }
    @media screen and (max-width: 900px){
        span, h4, p{
            text-align: center;
        }
    }
`;

const ContainerImage = styled.div`
    flex: 1;
    /* padding: 0rem 1rem; */
    img{
        width: 100%;
        height: auto;
        /* object-fit: contain; */
        padding: 2rem;
    }
    @media screen and (max-width: 900px){
        img{
            padding: 0;
        }
    }
`